import { modalHandler } from "./namespace/modalHandler";
import { officialSuitSwiper } from "./namespace/officialSuitSwiper";

function officialSuits() {
  officialSuitSwiper();
  modalHandler();
}

export { officialSuits };
